import React, { FC } from 'react';
import { Modal, Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as YourSvg } from '../../images/pop_up.svg';

interface NewAppProps {
  open: boolean;
  onClose: () => void;
}

const NewApp: FC<NewAppProps> = ({ open, onClose }) => {
  const handleRedirect = () => {
    window.open(
      navigator.userAgent.match(/iPhone/i)
        ? 'https://apps.apple.com/cl/app/makana/id6745032291'
        : 'https://play.google.com/store/apps/details?id=cl.makana.mobile',
      '_blank',
    );
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 346,
          bgcolor: 'background.paper',
          borderRadius: 8,
          boxShadow: 24,
          p: 2,
          textAlign: 'center',
        }}>
        <IconButton
          onClick={() => {
            console.log('Close button clicked');
            onClose();
          }}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: '#38383D',
            '&:hover': {
              backgroundColor: 'rgba(56, 56, 61, 0.1)',
            },
          }}
          aria-label="cerrar">
          <CloseIcon />
        </IconButton>
        <Box sx={{ mb: 3 }}>
          <YourSvg />
        </Box>
        <Typography
          id="modal-title"
          variant="h4"
          component="h2"
          sx={{
            mb: 4,
            color: '#38383D',
            fontSize: 24,
            fontWeight: 600,
            height: 1.33,
          }}>
          ¡Tenemos una nueva app!
        </Typography>
        <Typography
          id="modal-description"
          variant="body2"
          sx={{
            my: 4,
            color: '#38383D',
            fontSize: 14,
            fontWeight: 400,
            height: 1.33,
          }}>
          Pronto esta versión dejará de funcionar. Descarga la nueva aplicación de Makana y sigue disfrutando tu plan
          personalizado.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={handleRedirect}
          sx={{
            mt: 8,
            px: 4,
            borderRadius: 16,
            textTransform: 'none',
            fontSize: '1.1rem',
            fontWeight: 'bold',
            width: '100%',
          }}>
          Descargar
        </Button>
      </Box>
    </Modal>
  );
};

export default NewApp;
